import React from 'react';
import OptionDetailContainerBase from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/Optiondetail';
import OptionDetailBase from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/Optiondetail';
import { useSelector } from 'react-redux';
import { isTableSet } from '../../Reducers/Configurator/Selectors';
import { withStyles } from '@material-ui/core';

const OptionDetail = withStyles({
  priceFormatted: ({ isTable }) =>
    isTable
      ? {
          display: 'none',
        }
      : {},
})(OptionDetailBase);

export const OptionDetailContainer = (props) => {
  const isTable = useSelector((state) => isTableSet(state.configurator.configuration.item));
  return <OptionDetailContainerBase {...props} Component={OptionDetail} isTable={isTable} />;
};

export default OptionDetailContainer;
